import { useMutation, useQueryClient } from "@tanstack/react-query"
import { makeCancelDocument } from "../../domain/use-cases/cancel-document"
import { httpDocumentRepository } from "../../data/repositories/document-repository"

const cancelDocument = makeCancelDocument(httpDocumentRepository)

export const useCancelDocument = () => {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (docId: string) => cancelDocument(docId),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["documents"] }),
  })
}
